import React from 'react';
import { useDispatch } from 'react-redux';
import { Button, DialogActions, DialogContent, DialogTitle } from '@mui/material';

import { Form, ResponsiveDialog, SimpleTextField, useSettings, useUserData, Utils } from 'app/main/components';

interface OrdersLinesAddNoteDialogProps {
	openDialog: boolean;
	closeDialog: VoidFunction;
	orderUid: string;
	updateRefresh: VoidFunction;
}

export default function OrdersLinesAddNoteDialog(props: OrdersLinesAddNoteDialogProps) {
	const dispatch = useDispatch();
	const { t } = useSettings();
	const userData = useUserData();

	const [noteText, setNoteText] = React.useState<string | null>(null);

	function addNote() {
		dispatch(Utils.alertProgressMsg(t));
		Utils.executeStored({
			action: 'st_orders_lines_add',
			dispatch,
			data: {
				orli_ords_uid: props.orderUid,
				orli_user_created_uid: userData.user_uid,
				lines: [{ orli_type: 'note', orli_description: noteText }]
			},
			successHandler: () => {
				dispatch(Utils.alertSuccessMsg(t));
				props.closeDialog();
				props.updateRefresh();
			}
		});
	}

	return (
		<ResponsiveDialog open={props.openDialog} onClose={props.closeDialog} maxWidth="sm" fullWidth>
			<DialogTitle>{t('DIALOG_ORDERS_LINES_DIALOG_ADD_NOTE_TITLE')}</DialogTitle>
			<DialogContent>
				<Form id="ordersAddNoteToDialog" onSubmit={addNote}>
					<SimpleTextField
						name="noteText"
						label={t('DETAILS_ORDERS_LINES_FIELD_DESCRIPTION')}
						value={noteText}
						sendChange={(_name, value) => setNoteText(value)}
						isEdit
						required
						validations={{ maxLength: 100 }}
						validationErrors={{
							isDefaultRequiredValue: t('ERROR_TEXT_REQUIRED'),
							maxLength: t('ERROR_TEXT_MAXLENGTH')
						}}
					/>
				</Form>
			</DialogContent>
			<DialogActions>
				<Button onClick={props.closeDialog}>{t('DIALOG_ACTION_CANCEL')}</Button>
				<Button type="submit" form="ordersAddNoteToDialog" color="secondary">
					{t('DIALOG_ACTION_ADD')}
				</Button>
			</DialogActions>
		</ResponsiveDialog>
	);
}
